let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eVKfF")).then(() => parcelRequire('kX158'));